
define('jsx!components/login-public-tenant/input-password',["react"], function (React)
{
	return React.createClass({
		displayName: "Password",
		getDefaultProps: function ()
		{
			return {
				"password": null,
				"valid": null,
				"setPassword": function () {},
				"incrementProgress": function () {},
				"decrementProgress": function () {},
				"handleEnterKeyUp": function () {},
				"isPebbleGoPortal": false,
				"passwordImage": null
			};
		},
		getInitialState: function ()
		{
			return {
				"password": this.props.password,
				"valid": null,
				"help_message": null
			}
		},
		handleChangeOnPassword: function (e)
		{
			this.setState({
				"password": e.currentTarget.value
			});

			if (this.validationTimeout) {
				clearTimeout(this.validationTimeout);
			}
			this.validationTimeout = setTimeout(this.validatePassword, 250);
		},
		handleKeyUpOnPassword: function (e)
		{
			if (e.charCode == 13 || e.keyCode == 13 || e.key == 13 || e.which == 13) {
				this.props.handleEnterKeyUp();
			}
		},
		validatePassword: function ()
		{
			try {
				if (typeof this.state.password !== "string" || this.state.password.length == 0) {
					throw new Error("Please enter a password.");
				}

				this.props.setPassword(this.state.password);
				this.setState({
					"valid": true,
					"help_message": null
				});
			} catch (err) {
				this.props.setPassword(null);
				this.setState({
					"valid": false,
					"help_message": err.message
				});
			}
		},
		componentDidUpdate: function (prevProps, prevState)
		{
			if (!prevState.valid && this.state.valid === true) {
				this.props.incrementProgress();
			} else if (!this.state.valid && prevState.valid === true) {
				this.props.decrementProgress();
			}
		},
		renderHelpBlock: function ()
		{
			if (this.state.valid) {
				return null;
			}

			return (
				React.createElement("span", {className: "help-block"}, this.state.help_message)
			);
		},
		render: function ()
		{
			var classNames = ['form-group'];
			
			if (this.props.isPebbleGoPortal) {
				classNames.push("password");

				return (
					React.createElement("div", {className: classNames.join(" ")}, 
						React.createElement("span", {className: "password-header"}, "Enter Password"), 
						React.createElement("input", {
							type: "password", 
							className: "password-input", 
							name: "password", 
							placeholder: "Top Secret Password", 
							id: "input-password", 
							value: this.state.password, 
							onChange: this.handleChangeOnPassword, 
							onKeyUp: this.handleKeyUpOnPassword, 
							"aria-label": "password", 
							autoFocus: true}
							), 
						React.createElement("img", {className: "password-icon-graphic", src: this.props.passwordImage, alt: "password-icon"})
					)
				);
			} else {
				if (this.state.valid === true) {
					classNames.push("has-success");
				} else if (this.state.valid === false) {
					classNames.push("has-error");
				}
	
				return (
					React.createElement("div", {className: classNames.join(" ")}, 
						React.createElement("input", {
							type: "password", 
							className: "form-control", 
							name: "password", 
							placeholder: "Password", 
							id: "input-password", 
							value: this.state.password, 
							onChange: this.handleChangeOnPassword, 
							onKeyUp: this.handleKeyUpOnPassword, 
							"aria-label": "password", 
							autoFocus: true}
							), 
	
						 this.renderHelpBlock(), 
	
						React.createElement("span", {style: {display: "inline-block",width: "100%",textAlign: "right"}}, React.createElement("a", {href: "/reset-password"}, "Forgot Password?"))
					)
				);
			}
			
		}
	});
});
